"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var idm_crosscutting_concepts_frontend_1 = require("@synisys/idm-crosscutting-concepts-frontend");
var immutable_1 = require("immutable");
var lodash_1 = require("lodash");
function deserializeMultilingualString(dto) {
    var builder = idm_crosscutting_concepts_frontend_1.MultilingualString.newBuilder();
    Object.getOwnPropertyNames(dto).forEach(function (languageId) {
        return builder.withValueForLanguage(Number(languageId), dto[languageId]);
    });
    return builder.build();
}
exports.deserializeMultilingualString = deserializeMultilingualString;
function serializeMultilingualString(multilingualString) {
    var dto = {};
    multilingualString.toMap().forEach(function (value, key) {
        lodash_1.set(dto, key, value);
    });
    return dto;
}
exports.serializeMultilingualString = serializeMultilingualString;
function deserializeIfMultilingual(obj) {
    if (!lodash_1.isNil(obj) && obj.hasOwnProperty('_values')) {
        return lodash_1.entries(obj['_value'])
            .reduce(function (previousValue, currentValue) {
            return previousValue.withValueForLanguage(Number(currentValue[0]), currentValue[1]);
        }, idm_crosscutting_concepts_frontend_1.MultilingualString.newBuilder())
            .build();
    }
    else {
        return obj;
    }
}
exports.deserializeIfMultilingual = deserializeIfMultilingual;
function deserializeArrays(obj) {
    return lodash_1.mapValues(obj, function (value) {
        if (lodash_1.isPlainObject(value)) {
            return deserializeArrays(value);
        }
        else if (Array.isArray(value)) {
            return immutable_1.List(value.map(function (item) { return deserializeArrays(item); }));
        }
        else {
            return value;
        }
    });
}
exports.deserializeArrays = deserializeArrays;
function deserializeMultilingual(hint) {
    if (lodash_1.isNil(hint)) {
        return undefined;
    }
    if (hint instanceof idm_crosscutting_concepts_frontend_1.MultilingualString) {
        return hint;
    }
    if (lodash_1.isString(hint)) {
        return stringToMultilingual(hint);
    }
    if (lodash_1.isPlainObject(hint)) {
        var builder_1 = idm_crosscutting_concepts_frontend_1.MultilingualString.newBuilder();
        lodash_1.entries(hint).forEach(function (_a) {
            var key = _a[0], value = _a[1];
            builder_1.withValueForLanguage(parseInt(key, 10), value);
        });
        return builder_1.build();
    }
    return undefined;
}
exports.deserializeMultilingual = deserializeMultilingual;
function stringToMultilingual(json) {
    if (json === '') {
        return undefined;
    }
    var multilingualString = JSON.parse(json);
    var builder = idm_crosscutting_concepts_frontend_1.MultilingualString.newBuilder();
    for (var key in multilingualString) {
        if (multilingualString.hasOwnProperty(key)) {
            builder.withValueForLanguage(+key, multilingualString[key]);
        }
    }
    return builder.build();
}
exports.stringToMultilingual = stringToMultilingual;
function isEmptyMultilingual(multilingual) {
    return (lodash_1.isNil(multilingual) ||
        lodash_1.isEmpty(multilingual) ||
        lodash_1.isNil(multilingual.toMap) ||
        lodash_1.isEmpty(multilingual.toMap()));
}
exports.isEmptyMultilingual = isEmptyMultilingual;
//# sourceMappingURL=serialization.utilities.js.map